import { useEffect, useState } from "react";
import styles from "./Home.module.css";
import ButtonDivider from "../components/ButtonDivider";
import PageButton from "../components/PageButton";

import imgBtnBillboards from "../assets/images/modThumbnails/steedie_ads.webp";
import imgBtnMods from "../assets/images/buttonThumbnails/steedie_contrabandrv.webp";

import imgSteamLogin from "../assets/images/signinSteam.png";

const CACHE_KEY = "billboardsCache";
const CACHE_INDEX_KEY = "billboardsIndexCache";
const CACHE_EXPIRATION = 30 * 1000;

function ActiveImages({ user }) {
  const [billboards, setBillboards] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!user) return;

    const fetchBillboards = async () => {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        const { timestamp, data } = JSON.parse(cached);
        if (Date.now() - timestamp < CACHE_EXPIRATION) {
          setBillboards(data);
          return;
        }
      }

      const res = await fetch(
        "https://eynulcvqk1.execute-api.eu-central-1.amazonaws.com/get-billboards-s3-jwt",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.jwt}`,
          },
        }
      );

      if (res.ok) {
        const data = await res.json();
        setBillboards(data);
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ timestamp: Date.now(), data })
        );
      }
    };

    fetchBillboards();
  }, [user]);

  useEffect(() => {
    const cachedIndex = localStorage.getItem(CACHE_INDEX_KEY);
    if (cachedIndex !== null) {
      setCurrentIndex(Number(cachedIndex));
    }
  }, []);

  useEffect(() => {
    if (billboards.length === 0) return;

    if (currentIndex >= billboards.length) {
      setCurrentIndex(0);
      localStorage.setItem(CACHE_INDEX_KEY, 0);
    }

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % billboards.length;
        localStorage.setItem(CACHE_INDEX_KEY, nextIndex);
        return nextIndex;
      });
    }, 6000);

    return () => clearInterval(interval);
  }, [billboards, currentIndex]);

  return (
    <>
      {billboards.length > 0 && (
        <img src={billboards[currentIndex]} alt="Live Billboard" />
      )}
    </>
  );
}

function SignInPrompt() {
  return (
    <div className={styles.signInPrompt}>
      <h3>Sign in to view live billboards</h3>
      <button
        className={styles.steamBtn}
        onClick={() => {
          const redirectUri = window.location.href;
          window.location.href = `https://eynulcvqk1.execute-api.eu-central-1.amazonaws.com/auth/steam?redirectUri=${encodeURIComponent(
            redirectUri
          )}`;
        }}
      >
        <img
          src={imgSteamLogin}
          alt="Sign in with Steam"
          className={styles.steamImage}
        />
      </button>
    </div>
  );
}

function Home({ user }) {
  return (
    <>
      <div className={styles.home}>
        <div className={styles.left}>
          <ButtonDivider text={"MORDHAU"} />
          <PageButton
            img={imgBtnBillboards}
            title={"steedie_billboards"}
            description={`Get your image displayed to thousands of players across a network of
          servers`}
            nav={"/billboards"}
          />
          <PageButton
            img={imgBtnMods}
            title={"steedie_mods"}
            description={`See Steedie Mordhau mods with 800,000+ downloads`}
            nav={"/mods"}
          />
        </div>
        <div className={styles.right}>
          {user ? <h2>Showing on billboards now</h2> : <></>}
          <div className={styles.imgView}>
            {user ? <ActiveImages user={user} /> : <SignInPrompt />}
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
